import React, { useContext, Fragment, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { withTranslation } from 'react-i18next';
import { authContext } from "../context/AuthContext";

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LandingCard from './helper/LandingCard';
import LandingCard2 from './helper/LandingCard2';

const styles = theme => ({
    root: {
        '& a': {
            color: 'white'
        }
    },
    card: {
        height: '100%',
    },
    media: {
        height: 200,
    },
});

const Main = props => {
    const history = useHistory();
    const {authenticated, user} = useContext(authContext);
    useEffect(() => {
        // on mount
        handleResize()
        window.addEventListener('resize', handleResize);

        // on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    // Make the description height the same for all cards
    const handleResize = () => {

        let cardDetails = document.querySelectorAll('.MuiCardContent-root');
        let detailsMaxHeight = 0;

        cardDetails.forEach((detail) => {
            detail.style.minHeight = null;
            detailsMaxHeight = (detail.offsetHeight > detailsMaxHeight) ? detail.offsetHeight : detailsMaxHeight;
        });
        cardDetails.forEach((detail) => detail.style.minHeight = detailsMaxHeight + "px");
    }

    function setSelf() {
        sessionStorage.setItem('userTrack', "S");
        if (authenticated) {
            history.push('/dashboard/trainingMain');
        } else {
            history.push('/login');
        }
    }

    function setEmployerContact() {
        sessionStorage.setItem('userTrack', "E");

        if (authenticated) {
            history.push('/dashboard/employers/' + user.username);
        } else {
            history.push('/login');
        }
    }
     function setZoomClass() {
        sessionStorage.setItem('userTrack', "Z");

        if (authenticated) {
            history.push('/zoomClass');
        } else {
            history.push('/login');
        }
    }

    const { t } = props;
    const { classes } = props;

    return (
        <Fragment>
            <div>
                <Box pb={3} mt={4} mb={4} borderBottom={1} borderColor="#E0E0E0">
                    <Grid container spacing={3} justifyContent="space-between">
                        <Grid item>
                            <h2 className="page-heading">{t('title')}</h2>
                        </Grid>
                    </Grid>
                </Box>
            </div>

            <div>
                <p>{t('description1')}</p>
                <p>{t('description2')}</p>
                <p>{t('description3')}</p>
                <br /><br />

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                        <LandingCard classes={{ ...classes }} link={"/classes"} image={"/images/classroom.jpg"} title={t('classroom.title')} description={t('classroom.description')} />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <LandingCard2 classes={{ ...classes }} onClick={setSelf}  image={"/images/online.jpg"} title={t('online.title')} description={t('online.description')}  />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <LandingCard2 classes={{ ...classes }} onClick={setZoomClass}  image={"/images/zoom.jpg"} title={t('zoom.title')} description={t('zoom.description')} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <LandingCard2 classes={{ ...classes }} onClick={setEmployerContact}  image={"/images/employer.jpeg"} title={t('employer.title')} description={t('employer.description')} />
                    </Grid>
                    
                </Grid>
            </div>
        </Fragment >
    );
}

// export default withTranslation()(Main);
export default withStyles(styles, { withTheme: true })(withTranslation()(Main));
